/**
 * @typedef {object} AutorizacionSolicitud
 * @property {string} [recursoTipo]
 * @property {string | { toString(): string }} [recursoId]
 * @property {{ titulo?: string, cursoTitulo?: string }} [payload]
 */

/**
 * @param {AutorizacionSolicitud | null | undefined} solicitud
 * @returns {string}
 */
export function getAutorizacionCursoLabel(solicitud) {
  if (!solicitud || typeof solicitud !== "object") {
    return "—";
  }

  const payload = solicitud.payload;
  if (payload && typeof payload === "object") {
    if (typeof payload.titulo === "string" && payload.titulo.trim() !== "") {
      return payload.titulo.trim();
    }
    if (typeof payload.cursoTitulo === "string" && payload.cursoTitulo.trim() !== "") {
      return payload.cursoTitulo.trim();
    }
  }

  const recursoId = solicitud.recursoId;
  if (recursoId != null) {
    const idText = typeof recursoId === "string" ? recursoId : String(recursoId);
    const trimmedId = idText.trim();
    if (trimmedId !== "") {
      return trimmedId;
    }
  }

  return solicitud.recursoTipo === "curso" ? "Curso" : "—";
}
